import { ThemeProvider, theme } from "@primer/react";
import deepmerge from "deepmerge";
import { AuthProvider } from "oidc-react";
import { useEffect, useMemo } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import BaseStyles from "./BaseStyles";
import LoaderPage from "./components/loader-page";
import AuthorizedContent from "./content/AuthorizedContent";
import SigoutContent from "./content/SigoutContent";
import UnAuthorizedContent from "./content/UnAuthorizedContent";
import { CommonProvider } from "./contexts/common";
import { actions } from "./state/actions/actionsWrapper";
import { localizedResourceAction } from "./state/actions/localized-resource/localizedResourceAction";
import { RootState } from "./state/reducers";
import { eAccountReducerStatus } from "./state/reducers/authReducer";
import PubicContent from "./PubicContent";

const customTheme = deepmerge(
  {
    ...theme,
    fontSizes: [
      "11px",
      "13px",
      "16px",
      "20px",
      "24px",
      "32px",
      "40px",
      "48px",
      "56px",
    ],
    radii: ["4px", "6px", "8px", "12px"],
  },
  {
    colorSchemes: {
      light: {
        colors: {
          accent: {
            fg: "#0969da",
            emphasis: "#0969da",
          },
          btn: {
            bg: "#fff",
            primary: {
              bg: "#0969da",
              focusBg: "#0969da",
              hoverBg: "#0969da",
              selectedBg: "#0969da",
              disabledBg: "rgba(84, 174, 255, 0.4)",
            },
          },
          primer: {
            border: {
              active: "#0969da",
            },
          },
        },
      },
    },
  }
);
const publicPath: string[] = ["/live-checkin-private", "/live-checkin"];

function App() {
  const { user_info, status, isSignOuted } = useSelector(
    (x: RootState) => x.auth
  );
  const { language } = useSelector((x: RootState) => x.common);
  const { appConfig } = useSelector((x: RootState) => x.appConfig);
  const path = window.location.pathname;

  const isPublicPage = useMemo(() => {
    return publicPath.some((value) => path.includes(value));
  }, [path]);

  const dispatch = useDispatch();
  useEffect(() => {
    if (!isPublicPage) {
      dispatch(localizedResourceAction.loadStart(language));
    }
  }, [language, isPublicPage, dispatch]);
  useEffect(() => {
    if (!isPublicPage) {
      dispatch(actions.appConfig.loadStart());
    }
  }, [dispatch, isPublicPage]);
  const oidcConfig: any = useMemo(() => {
    if (!appConfig) {
    }
    return {
      onSignIn: (e: any) => { },
      authority: appConfig?.OIDC_AUTHORITY,
      clientId: appConfig?.OIDC_CLIENT_ID,
      redirectUri: appConfig?.OIDC_REDIRECT_URI,
      clientSecret: appConfig?.OIDC_CLIENT_SECRET,
    };
  }, [appConfig]);

  useEffect(() => {
      if (localStorage.getItem("access_token")) {
        dispatch(actions.account.getUserStart());
      }
  }, [dispatch, isPublicPage]);

  if (status === eAccountReducerStatus.is_getting_profile) {
    return <LoaderPage />;
  }
  
  return (
    <Router>
      <ThemeProvider theme={customTheme} colorMode={"light"}>
        <BaseStyles>
          {isPublicPage &&
            <CommonProvider>
              <PubicContent />
            </CommonProvider>
          }
          {!isPublicPage &&
            <>
              <CommonProvider>
                <>
                  {isSignOuted === true && (
                    <AuthProvider {...oidcConfig}>
                      <SigoutContent />
                    </AuthProvider>
                  )}
                  {isSignOuted !== true && (
                    <>
                      {
                        user_info && (
                          // <HubProvider>
                          <AuthorizedContent />
                        )
                        // </HubProvider>
                      }
                      {!user_info && <UnAuthorizedContent />}
                    </>
                  )}
                </>
              </CommonProvider>
            </>
          }

        </BaseStyles>
      </ThemeProvider>
    </Router>
  );
}

export default App;
